import React, { isValidElement, cloneElement, Children } from "react";
export // Shared React primitives. Attribute metadata comes only from internal action helpers.
function attributes(text = "") {
  const props = {};
  const names = {
    readonly: "readOnly",
    maxlength: "maxLength",
    minlength: "minLength",
    tabindex: "tabIndex",
    autocomplete: "autoComplete",
    class: "className",
    for: "htmlFor",
  };
  for (const m of String(text).matchAll(
    /([\w-]+)(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s]+)))?/g,
  )) {
    const key = names[m[1]] || m[1],
      value = m[2] ?? m[3] ?? m[4];
    props[key] = [
      "disabled",
      "required",
      "readOnly",
      "multiple",
      "checked",
      "selected",
    ].includes(key)
      ? true
      : (value ?? "");
  }
  return props;
}
export function nodes(items) {
  return items.map((item, i) =>
    isValidElement(item)
      ? cloneElement(item, {
          key: item.key ?? i,
        })
      : item,
  );
}
export function lineBreaks(items) {
  return items.map((item, i) => (
    <React.Fragment key={i}>
      {i > 0 && <br />}
      {item}
    </React.Fragment>
  ));
}
export function flatten(elements) {
  return Children.toArray(elements).flatMap((el) =>
    isValidElement(el) && el.type === React.Fragment
      ? flatten(el.props.children)
      : [el],
  );
}
